"use client"
import { useTrackPageView } from "@/hooks/_archive/global/analytics/useTrackPageView"

export function TrackPageView({ pageName }: { pageName: string }) {
  useTrackPageView(pageName)
  return null
}
